import {
  USER_CHANGE
} from 'actions/user';

const initialState = {
  id: '10'
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case USER_CHANGE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default user;


// WEBPACK FOOTER //
// ./src/reducers/user.js